<template>
  <SidebarComponent ref="sidebar">
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="gradient-border rounded-circle w-100 h-100 m-auto">
          <AvatarComponent :image="contact.profile_picture"
                           :name="`${contact.first_name} ${contact.last_name}`"
                           size="lg"></AvatarComponent>
        </div>
      </div>
      <div class="col-md-12 m-t-30 text-center">
        <h5 class="card-title m-b-5">{{ contact.first_name }} {{ contact.last_name }}</h5>
      </div>
    </div>
    <ul class="d-flex text-center ml-auto mr-auto p-0 m-t-20 justify-content-between max-w-200">
      <li class="d-inline-block">
        <a href="javascript:void(0)" class="d-block" @click="sendMessage('SmsSend')">
          <i>
            <svg id="SMS" xmlns="http://www.w3.org/2000/svg" width="21.58" height="20.45"
                 viewBox="0 0 19 18.005">
              <path id="sms_FILL0_wght400_GRAD0_opsz48"
                    d="M4,21.29V5.425a1.38,1.38,0,0,1,.427-.986,1.35,1.35,0,0,1,1-.439h16.15a1.363,1.363,0,0,1,.986.439A1.363,1.363,0,0,1,23,5.425v12.35A1.507,1.507,0,0,1,21.575,19.2H7.8L5.211,21.789a.659.659,0,0,1-.772.154A.651.651,0,0,1,4,21.29Zm1.425-1.734,1.781-1.781H21.575V5.425H5.425Zm0-14.131h0v12.35h0V5.425Z"
                    transform="translate(-4 -4)"></path>
              <path id="Path_1243" data-name="Path 1243"
                    d="M.287-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,1.756-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135A.336.336,0,0,0,2.156-1.1a.364.364,0,0,0-.07-.22.757.757,0,0,0-.192-.179,2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5A1.094,1.094,0,0,1,.27-3.023,1.139,1.139,0,0,1,.4-3.587,1.12,1.12,0,0,1,.76-3.976,1.609,1.609,0,0,1,1.286-4.2a2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59A1.082,1.082,0,0,1,2.657-.2a1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,.828.015,1.985,1.985,0,0,1,.287-.161ZM8.631,0H7.7V-2.514q0-.407.035-.9H7.708a4.426,4.426,0,0,1-.132.557L6.592,0H5.818l-1-2.827a5.5,5.5,0,0,1-.132-.586H4.658q.038.621.038,1.09V0H3.844V-4.2H5.229l.858,2.49a3.506,3.506,0,0,1,.149.6h.018a6.047,6.047,0,0,1,.167-.606L7.28-4.2H8.631Zm.762-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,10.862-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135.336.336,0,0,0,.044-.168.364.364,0,0,0-.07-.22A.757.757,0,0,0,11-1.494a2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5,1.094,1.094,0,0,1-.242-.715,1.139,1.139,0,0,1,.132-.564,1.12,1.12,0,0,1,.359-.388,1.609,1.609,0,0,1,.526-.224,2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59,1.082,1.082,0,0,1-.362.387,1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,9.933.015,1.985,1.985,0,0,1,9.393-.161Z"
                    transform="translate(3 9)"></path>
            </svg>
          </i>
        </a>
      </li>
      <li class="d-inline-block">
        <a href="javascript:void(0)" class="d-block" @click="sendMessage('WhatsAppSend')">
          <i class="icon-font fab fa-whatsapp"></i>
        </a>
      </li>
      <li class="d-inline-block">
        <a href="javascript:void(0)" class="d-block" @click="sendMessage('MailSend')">
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="22.21" height="17.77"
                 viewBox="0 0 19 15.2">
              <path id="mail_FILL0_wght400_GRAD0_opsz48"
                    d="M5.425,23.2A1.461,1.461,0,0,1,4,21.775V9.425A1.461,1.461,0,0,1,5.425,8h16.15A1.461,1.461,0,0,1,23,9.425v12.35A1.461,1.461,0,0,1,21.575,23.2Zm16.15-12.469-7.7,5.035q-.1.048-.178.083a.59.59,0,0,1-.4,0q-.083-.036-.178-.083L5.425,10.731V21.775h16.15ZM13.5,14.6l7.98-5.177H5.544ZM5.425,10.731V21.775h0Z"
                    transform="translate(-4 -8)"></path>
            </svg>
          </i>
        </a>
      </li>
      <li class="d-inline-block">
        <a href="javascript:void(0)" class="d-block" @click="sendMessage('RCSSend')">
          <i class="icon-font fab fa-google"></i>
        </a>
      </li>
    </ul>
    <div class="row details">
      <div class="col-12">
        <div class="row">
          <div class="col-1 icon">
            <span class="material-icons-outlined">smartphone</span>
          </div>
          <div class="col-10">
            {{ contact.mobile_number }}
          </div>
        </div>
        <div class="row">
          <div class="col-1 icon">
            <span class="material-icons-outlined">call</span>
          </div>
          <div class="col-10">
            {{ contact.phone }}
          </div>
        </div>
        <div class="row">
          <div class="col-1 icon">
            <span class="material-icons-outlined">email</span>
          </div>
          <div class="col-10">
            {{ contact.email }}
          </div>
        </div>
        <div class="row">
          <div class="col-1 icon">
            <span class="material-icons-outlined">business</span>
          </div>
          <div class="col-10">
            {{ contact.company }}
          </div>
        </div>
        <div class="row">
          <div class="col-1 icon">
            <span class="material-icons-outlined">place</span>
          </div>
          <div class="col-10">
            {{ contact.address }} {{ contact.number }}<br/>
            {{ contact.city }} {{ contact.district }}
          </div>
        </div>
      </div>
    </div>
  </SidebarComponent>
</template>

<script>
import SidebarComponent from '@/components/SidebarComponent.vue';
import AvatarComponent from '@/components/ui/AvatarComponent.vue';

export default {
  name: 'ContactSidebarComponent',
  components: {
    AvatarComponent,
    SidebarComponent,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggle() {
      this.$refs.sidebar.toggle();
    },
    sendMessage(channel) {
      this.$router.push({
        name: channel,
        params: { contacts: [this.contact] },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sidebar-body {
  i {
    font-size: 19px;
    line-height: 1;
    color: #667085;

    svg {
      fill: #667085;
    }
  }
  .details {
    .icon {
      font-size: 20px;
      color: var(--clr-yup-purple);
    }
  }
}
</style>
